import InputRange from './InputRange'
import InputRangeField from './InputRangeField'

export default InputRange
export { InputRangeField }
